"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BootstrapTextArea = exports.BootstrapText = exports.BootstrapStatefulSelect = exports.BootstrapSelect = exports.BootstrapReactSelect = exports.BootstrapNumber = exports.BootstrapFieldWrapper = exports.BootstrapDateInput = exports.BootstrapChoiceSelect = exports.BootstrapCheckbox = exports.BaseBootstrapCheckbox = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _informed = require("informed");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fields = require("./fields");
var _date_input = _interopRequireDefault(require("./date_input"));
var _fa = _interopRequireDefault(require("../util/fa"));
var _basicReactSelect = _interopRequireDefault(require("./basicReactSelect"));
var _excluded = ["fieldState", "showLabel", "label", "helpText", "field", "required", "labelClassName", "prependText", "appendText", "error", "className"],
  _excluded2 = ["fieldState", "showLabel", "label", "helpText", "field", "required", "labelClassName"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BootstrapFieldWrapper = exports.BootstrapFieldWrapper = function BootstrapFieldWrapper(WrappedComponent) {
  var BootstrapWrapper = /*#__PURE__*/function (_Component) {
    function BootstrapWrapper(props) {
      var _this;
      (0, _classCallCheck2["default"])(this, BootstrapWrapper);
      _this = _callSuper(this, BootstrapWrapper, [props]);
      _this.state = {
        id: _this.props.id || (0, _lodash.uniqueId)("bootstrap-field-")
      };
      return _this;
    }
    (0, _inherits2["default"])(BootstrapWrapper, _Component);
    return (0, _createClass2["default"])(BootstrapWrapper, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          fieldState = _this$props.fieldState,
          showLabel = _this$props.showLabel,
          label = _this$props.label,
          helpText = _this$props.helpText,
          field = _this$props.field,
          required = _this$props.required,
          labelClassName = _this$props.labelClassName,
          prependText = _this$props.prependText,
          appendText = _this$props.appendText,
          error = _this$props.error,
          className = _this$props.className,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
        var hasError = fieldState.error !== null && fieldState.error !== undefined || error !== undefined;
        var newProps = {
          className: (0, _classnames["default"])("form-control", {
            "is-invalid": hasError
          }, className),
          id: this.state.id,
          fieldState: fieldState
        };
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _classnames["default"])("form-group", {
            "required": required,
            "is-invalid": hasError
          }, labelClassName)
        }, showLabel && /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: this.state.id
        }, label || field), prependText || appendText ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "input-group"
        }, prependText && /*#__PURE__*/_react["default"].createElement("div", {
          className: "input-group-prepend"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "input-group-text"
        }, prependText)), /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, newProps, rest)), appendText && /*#__PURE__*/_react["default"].createElement("div", {
          className: "input-group-append"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "input-group-text"
        }, appendText))) : /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, newProps, rest)), helpText && /*#__PURE__*/_react["default"].createElement("small", {
          className: "form-text text-muted"
        }, /*#__PURE__*/_react["default"].createElement("i", null, helpText)), fieldState.error !== null && fieldState.error !== undefined ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "invalid-feedback"
        }, fieldState.error) : error !== undefined ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "invalid-feedback"
        }, error) : null);
      }
    }]);
  }(_react.Component);
  BootstrapWrapper.defaultProps = {
    showLabel: true,
    prependText: null,
    appendText: null
  };
  BootstrapWrapper.propTypes = {
    showLabel: _propTypes["default"].bool,
    label: _propTypes["default"].string,
    helpText: _propTypes["default"].string,
    prependText: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
    appendText: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
    className: _propTypes["default"].string
  };
  return (0, _informed.asField)(BootstrapWrapper);
};

// const BasicBootstrapCheckbox = ( props ) => {
//     let { className, ...rest } = props;
//     className = (className || "") + " custom-control-input";
//     console.log(props);
//
//     return (
//         <div className="checkbox">
//             <div className="custom-control custom-checkbox">
//                 <BasicCheckbox className={className} {...rest} />
//                 <label className="custom-control-label" htmlFor={props.id}>{props.label}</label>
//             </div>
//         </div>
//     )
// };
var BaseBootstrapCheckbox = exports.BaseBootstrapCheckbox = /*#__PURE__*/function (_Component2) {
  function BaseBootstrapCheckbox(props) {
    var _this2;
    (0, _classCallCheck2["default"])(this, BaseBootstrapCheckbox);
    _this2 = _callSuper(this, BaseBootstrapCheckbox, [props]);
    _this2.state = {
      id: _this2.props.id || (0, _lodash.uniqueId)("bootstrap-field-")
    };
    return _this2;
  }
  (0, _inherits2["default"])(BaseBootstrapCheckbox, _Component2);
  return (0, _createClass2["default"])(BaseBootstrapCheckbox, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        fieldState = _this$props2.fieldState,
        showLabel = _this$props2.showLabel,
        label = _this$props2.label,
        helpText = _this$props2.helpText,
        field = _this$props2.field,
        required = _this$props2.required,
        labelClassName = _this$props2.labelClassName,
        rest = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded2);
      var newProps = {
        className: (0, _classnames["default"])("custom-control-input form-check-input", {
          "is-invalid": fieldState.error
        }),
        id: this.state.id,
        fieldState: fieldState
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])("form-group", {
          "required": required,
          "is-invalid": fieldState.error
        }, labelClassName)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "custom-control custom-checkbox"
      }, /*#__PURE__*/_react["default"].createElement(_informed.BasicCheckbox, (0, _extends2["default"])({}, newProps, rest)), /*#__PURE__*/_react["default"].createElement("label", {
        className: (0, _classnames["default"])("custom-control-label", labelClassName),
        htmlFor: this.state.id
      }, label))), helpText && /*#__PURE__*/_react["default"].createElement("small", {
        className: "form-text text-muted"
      }, /*#__PURE__*/_react["default"].createElement("i", null, helpText)), fieldState.error && /*#__PURE__*/_react["default"].createElement("div", {
        className: "invalid-feedback"
      }, fieldState.error));
    }
  }]);
}(_react.Component);
var BasicNumber = /*#__PURE__*/function (_Component3) {
  function BasicNumber() {
    (0, _classCallCheck2["default"])(this, BasicNumber);
    return _callSuper(this, BasicNumber, arguments);
  }
  (0, _inherits2["default"])(BasicNumber, _Component3);
  return (0, _createClass2["default"])(BasicNumber, [{
    key: "getValue",
    value: function getValue() {
      var fieldApi = this.props.fieldApi;
      var value = fieldApi.getValue();
      value = parseInt(value);
      if (isNaN(value)) {
        value = 0;
      }
      return value;
    }
  }, {
    key: "increase",
    value: function increase() {
      var fieldApi = this.props.fieldApi;
      fieldApi.setValue(this.getValue() + 1);
    }
  }, {
    key: "decrease",
    value: function decrease() {
      var fieldApi = this.props.fieldApi;
      fieldApi.setValue(this.getValue() - 1);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "number-input"
      }, /*#__PURE__*/_react["default"].createElement(_informed.BasicText, (0, _extends2["default"])({}, this.props, {
        type: "number"
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: "number-input-minus",
        onClick: this.decrease.bind(this)
      }, /*#__PURE__*/_react["default"].createElement(_fa["default"], {
        icon: "minus"
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: "number-input-plus",
        onClick: this.increase.bind(this)
      }, /*#__PURE__*/_react["default"].createElement(_fa["default"], {
        icon: "plus"
      })));
    }
  }]);
}(_react.Component);
var BootstrapSelect = exports.BootstrapSelect = BootstrapFieldWrapper(_informed.BasicSelect); // does not work with informed?
var BootstrapText = exports.BootstrapText = BootstrapFieldWrapper(_informed.BasicText);
var BootstrapNumber = exports.BootstrapNumber = BootstrapFieldWrapper(BasicNumber);
var BootstrapTextArea = exports.BootstrapTextArea = BootstrapFieldWrapper(_informed.BasicTextArea);
var BootstrapChoiceSelect = exports.BootstrapChoiceSelect = BootstrapFieldWrapper(_fields.ChoiceBasicSelect); //does not work with informed?
var BootstrapReactSelect = exports.BootstrapReactSelect = BootstrapFieldWrapper(_basicReactSelect["default"]);
var BootstrapCheckbox = exports.BootstrapCheckbox = (0, _informed.asField)(BaseBootstrapCheckbox);
var BootstrapDateInput = exports.BootstrapDateInput = BootstrapFieldWrapper(_date_input["default"]);
var BootstrapStatefulSelect = exports.BootstrapStatefulSelect = BootstrapFieldWrapper(_fields.ChoiceStatefulSelect);